import { getGUID } from 'core/utils';
import { TransformedSummarizationResult, TransformSentences } from '../models/transformation';
import { getSortedScores } from './logic';

interface IRespose {
  id: string;
  scores: number[];
  sentences: string[];
  type: 'ext' | 'abs';
  modelId: string;
}

export const transformExtResponse = (res: IRespose): TransformedSummarizationResult => {
  const sentences: TransformSentences = {};
  const sentenceSequence: string[] = [];

  res.sentences.forEach((sentence, index) => {
    const sentenceId = getGUID();
    sentences[sentenceId] = {
      text: sentence,
      score: res.scores[index],
      sentenceId,
    };
    sentenceSequence.push(sentenceId);
  });

  const sortedScores = getSortedScores(res.scores);
  return {
    sentences,
    sentenceSequence,
    scores: res.scores,
    sortedScores,
    id: res.id,
    summarySentenceSequence: [],
    summaryMode: res.type,
    modelId: res.modelId,
  };
};
